module.exports = __webpack_public_path__ + "img/Rewind.9e55cd84.png";